import { GenericFailure } from '@playq/services-shared';

import { getErrorMessage } from './handleError';

export function throwGenericFailure(e: GenericFailure) {
  throw new Error(getErrorMessage(e));
}
